import { render, staticRenderFns } from "./save-button.vue?vue&type=template&id=895c4b50&"
import script from "./save-button.vue?vue&type=script&lang=js&"
export * from "./save-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports